import type { CityConfig } from "../city-template/types";

export const cumberlandConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Maine Vital Records (Birth, Death, Marriage, Divorce)", href: "https://www.maine.gov/dhhs/mecdc/public-health-systems/data-research/vital-records/", description: "Official Maine CDC vital records office in Augusta" },
    { label: "Cumberland County Probate Court — Marriage Licenses", href: "https://www.cumberlandcounty.org/361/Probate-Court", description: "Cumberland County Probate Court" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Maine CDC for online vital record orders" },
  ],
  city: "Cumberland",
  state: "Maine",
  stateAbbr: "ME",
  slug: "cumberland",
  route: "/cumberland-me",
  title: "Emergency Passport Cumberland, ME — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Cumberland, Maine — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Cumberland, Falmouth, Yarmouth, North Yarmouth, and Cumberland County. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Cumberland, ME",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Cumberland and Cumberland County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Cumberland%20Maine%20rural%20landscape%20with%20rolling%20green%20hills%20and%20farmland%2C%20suburban%20Cumberland%20County%20with%20classic%20New%20England%20homes%20and%20tree-lined%20roads%2C%20scenic%20view%20of%20the%20Cumberland%20countryside%20near%20the%20Presumpscot%20River%2C%20summer%20afternoon%20light%20with%20green%20meadows%20and%20white%20colonial%20farmhouses%2C%20professional%20travel%20photography%2C%20wide%20angle%20scenic%20view%20of%20Cumberland%20Maine&width=1800&height=700&seq=cumberland-me-hero-001&orientation=landscape",
  heroImageAlt: "Cumberland Maine rural countryside with green hills and classic New England homes",
  geoPosition: "43.7965;-70.2588",
  geoPlacename: "Cumberland, Maine",
  lastModified: "2026-06-01",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "5 Custom House St, Boston, MA 02110",
    distance: "Located in Boston — approximately 115 miles (2 hours) from Cumberland, ME",
  },
  nearbyCitiesZips: [
    { name: "Cumberland", zips: "04021" },
    { name: "Falmouth", zips: "04105" },
    { name: "Yarmouth", zips: "04096" },
    { name: "North Yarmouth", zips: "04097" },
    { name: "Portland", zips: "04101" },
    { name: "Westbrook", zips: "04092" },
    { name: "Freeport", zips: "04032" },
    { name: "New Gloucester", zips: "04260" },
    { name: "Gray", zips: "04039" },
    { name: "Windham", zips: "04062" },
    { name: "Gorham", zips: "04038" },
    { name: "Scarborough", zips: "04074" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Cumberland departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Fast passport renewal in Falmouth", route: "/falmouth" },
    { name: "Emergency passport help in Yarmouth", route: "/yarmouth" },
    { name: "Urgent passport services in Portland", route: "/portland-me" },
    { name: "Same-day passport help in Freeport", route: "/freeport" },
    { name: "Expedited passport services in Westbrook", route: "/westbrook" },
    { name: "Passport courier services in Gorham", route: "/gorham" },
    { name: "Rush passport help in Windham", route: "/windham" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Cumberland, Maine remotely via secure courier. We do not have a walk-in office in Cumberland — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Cumberland travelers.",
  fpcOfficeAddress: "One Boston Place, #2600, Boston, MA 02108",
  fpcOfficeDistance: "Serving the greater Cumberland and Cumberland County area",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Cumberland and Cumberland County. From the quiet rural neighborhoods and rolling farmland of Cumberland to the nearby suburbs of Falmouth and Yarmouth — we help Cumberland travelers get their passports fast, often in 24–48 hours through our registered courier service.",
  nearbyCitiesIntro: "We serve all Cumberland neighborhoods and nearby towns including Falmouth, Yarmouth, North Yarmouth, Portland, Westbrook, Freeport, New Gloucester, Gray, Windham, Gorham, and Scarborough.",
  howItWorksIntro: "Most Cumberland travelers complete everything online and ship documents overnight. No need to drive to Boston or Portland. Our emergency and expedited passport process is designed for Maine travelers who need fast, reliable results.",
  mistakesIntro: "Cumberland is a peaceful rural suburb with many families commuting to Portland or Freeport. Residents often need passports at short notice for family trips or business travel. Here are the most common mistakes we see from Cumberland-area travelers.",
  testimonialsIntro: "Cumberland travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Cumberland? Here are the most common ones we hear from Cumberland County travelers.",
  statePageRoute: "/states/maine",
  statePageName: "Maine",
  dmvWebsite: "https://www.maine.gov/sos/bmv",
  dmvLabel: "Maine BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Cumberland international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer R.",
      location: "Cumberland, ME",
      rating: 5,
      text: "Realized my passport was expired 4 days before our family trip to Ireland. Fast Passport Center got my renewal done in 2 days. From our Cumberland home to Dublin with zero stress. Incredible service.",
      service: "Passport Renewal",
    },
    {
      name: "Paul D.",
      location: "Falmouth, ME",
      rating: 5,
      text: "Emergency business trip to London with 48 hours notice. Fast Passport Center had my emergency passport ready in 24 hours. The shipping from the Cumberland area was seamless.",
      service: "Emergency Passport",
    },
    {
      name: "Mary K.",
      location: "North Yarmouth, ME",
      rating: 5,
      text: "Lost my passport right before our cruise to Alaska. Fast Passport Center handled the DS-64 form and had my replacement in 3 days. They saved our family vacation.",
      service: "Lost Passport",
    },
    {
      name: "Tom S.",
      location: "Yarmouth, ME",
      rating: 5,
      text: "Passport renewal for our daughter's exchange program to France. Fast Passport Center helped us navigate the process and got the passport in 5 days. The whole experience was excellent.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "cumberland-1",
      name: "Cumberland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "15 Blanchard Rd",
      city: "Cumberland",
      state: "ME",
      zip: "04021",
      phone: "(207) 829-3366",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "In the center of Cumberland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main passport acceptance facility for Cumberland. Call ahead for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "cumberland-2",
      name: "Falmouth Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5 Falmouth Rd",
      city: "Falmouth",
      state: "ME",
      zip: "04105",
      phone: "(207) 781-4130",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles from Cumberland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger facility with more appointment slots. Popular for Cumberland and Falmouth residents.",
      icon: "ri-mail-line",
    },
    {
      id: "cumberland-3",
      name: "Yarmouth Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "15 Forest Falls Dr",
      city: "Yarmouth",
      state: "ME",
      zip: "04096",
      phone: "(207) 846-3831",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles from Cumberland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Good option for Cumberland residents near Yarmouth.",
      icon: "ri-mail-line",
    },
    {
      id: "cumberland-4",
      name: "Portland Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "125 Forest Ave",
      city: "Portland",
      state: "ME",
      zip: "04101",
      phone: "(207) 871-8387",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles from Cumberland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest facility in the region. Most appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "cumberland-5",
      name: "Cumberland Town Office",
      type: "Municipal Passport Acceptance",
      address: "290 Tuttle Rd",
      city: "Cumberland",
      state: "ME",
      zip: "04021",
      phone: "(207) 829-2205",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "In downtown Cumberland",
      website: "https://www.cumberlandmaine.com/",
      websiteLabel: "Cumberland Town Office",
      notes: "Town clerk services. Call ahead to confirm passport acceptance hours.",
      icon: "ri-government-line",
    },
    {
      id: "cumberland-6",
      name: "Freeport Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5 Bow St",
      city: "Freeport",
      state: "ME",
      zip: "04032",
      phone: "(207) 865-4468",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles from Cumberland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Cumberland residents near the Freeport border.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive to Boston", fpc: "No — ship from home" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Local Cumberland photo shops may use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Cumberland acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Cumberland applicants show up with incorrect checks and have to reschedule.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Cumberland families.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Cumberland travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location near Cumberland." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Cumberland address — trackable every step of the way." },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Cumberland, Maine?",
      a: "Fast Passport Center offers emergency passport processing in Cumberland in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, bypassing standard mail delays.",
    },
    {
      q: "Can I get a same-day passport in Cumberland, Maine?",
      a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option.",
    },
    {
      q: "Where can I get a fast passport renewal in Cumberland, Maine?",
      a: "Fast Passport Center offers fast passport renewal in Cumberland with no office visit required. Simply complete your application online, ship your documents using our prepaid overnight label, and our couriers handle the rest.",
    },
    {
      q: "How far is Cumberland from the Boston Passport Agency?",
      a: "Cumberland is approximately 115 miles from the Boston Passport Agency — about a 2-hour drive. With Fast Passport Center, you avoid that trip entirely.",
    },
    {
      q: "What acceptance facilities are near Cumberland, Maine?",
      a: "Options near Cumberland include the Cumberland Post Office (04021), Falmouth Post Office (04105), Yarmouth Post Office (04096), and Cumberland Town Office (04021). The Cumberland Post Office on Blanchard Rd is most convenient.",
    },
    {
      q: "Do I need to visit the Boston Passport Agency?",
      a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery.",
    },
    {
      q: "Is Cumberland close to Portland Jetport?",
      a: "Yes, Portland International Jetport (PWM) is only about 12 miles from Cumberland — roughly 20 minutes. It's the closest major airport for Cumberland travelers.",
    },
    {
      q: "How much does expedited passport service cost in Cumberland?",
      a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed. Contact us for a quote.",
    },
    {
      q: "What documents do I need for a first-time passport in Cumberland?",
      a: "You'll need proof of citizenship, government-issued photo ID, two passport photos, and payment. We provide a complete checklist and review your documents.",
    },
    {
      q: "Can you help with a child's passport in Cumberland?",
      a: "Yes. Child passports require both parents (or notarized consent), the child's birth certificate, and both parents' IDs. We walk Cumberland families through the process.",
    },
    {
      q: "Is there a UPS Store near Cumberland for shipping documents?",
      a: "Yes, there are UPS locations in Portland, Falmouth, and Freeport. We provide a prepaid overnight label. The Cumberland Post Office on Blanchard Rd also accepts packages.",
    },
    {
      q: "Can I get passport photos taken in Cumberland?",
      a: "Yes, CVS and Rite Aid in the Falmouth and Portland areas offer passport photo services. The Walgreens and CVS in Yarmouth are also convenient options.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Falmouth", address: "25 Falmouth Rd, Falmouth, ME 04105", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Falmouth", address: "5 Falmouth Rd, Falmouth, ME 04105", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Yarmouth", address: "15 Forest Falls Dr, Yarmouth, ME 04096", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Portland", address: "125 Forest Ave, Portland, ME 04101", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Portland", address: "125 Forest Ave, Portland, ME 04101", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo" },
    { name: "Walmart Photo Center — Portland", address: "200 John Roberts Rd, South Portland, ME 04106", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walmart.com/cp/photo/1078904" },
    { name: "Rite Aid — Portland", address: "50 Forest Ave, Portland, ME 04101", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com/photo" },
    { name: "Walgreens — Freeport", address: "30 Main St, Freeport, ME 04032", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/photo" },
  ],
  dmvLocations: [
    {
      name: "BMV — Portland",
      address: "25 Middlesex St, Portland, ME 04101",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Full-service BMV. 12 miles from Cumberland. Online appointment booking available.",
      featured: true,
    },
    {
      name: "BMV — Falmouth",
      address: "5 Falmouth Rd, Falmouth, ME 04105",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Cumberland County option. 5 miles from Cumberland.",
      featured: false,
    },
    {
      name: "BMV — Windham",
      address: "25 Windham Center Rd, Windham, ME 04062",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Cumberland County option. 15 miles from Cumberland.",
      featured: false,
    },
    {
      name: "BMV — Augusta",
      address: "29 State House Station, Augusta, ME 04333",
      hours: "Mon–Fri: 8AM–5PM",
      note: "State capital full-service BMV. 45 miles from Cumberland.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "PWM",
      name: "Portland International Jetport",
      distance: "12 miles from Cumberland (20 min)",
      address: "1001 Westbrook St, Portland, ME 04102",
      note: "Maine's busiest airport and closest to Cumberland. Direct flights to Boston, New York, Chicago, Philadelphia, and seasonal international connections. The best option for Cumberland travelers.",
      flightUrl: "https://www.portlandjetport.org/",
      flightLabel: "PWM Flight Info",
      featured: true,
    },
    {
      code: "BGR",
      name: "Bangor International Airport",
      distance: "110 miles from Cumberland (2 hours)",
      address: "2870 Godfrey Blvd, Bangor, ME 04401",
      note: "Maine's second busiest airport with direct flights to major hubs. Alternative for Cumberland travelers.",
      flightUrl: "https://www.flybangor.com/",
      flightLabel: "Bangor Airport",
      featured: false,
    },
    {
      code: "BOS",
      name: "Logan International Airport",
      distance: "115 miles from Cumberland (2 hours)",
      address: "1 Harborside Dr, Boston, MA 02128",
      note: "Major international hub with direct flights to Europe, Asia, and Latin America. Many Cumberland travelers drive to Boston for international travel.",
      flightUrl: "https://www.massport.com/logan-airport",
      flightLabel: "Logan Airport",
      featured: false,
    },
  ],
};